@if (isVisible) {
  <div class="export-tracking-overlay" (click)="onClose()"></div>
  <div class="export-tracking-panel" (click)="$event.stopPropagation()">
    <nz-card [nzBodyStyle]="{padding: '16px'}">
      <!-- Lista de exportaciones -->
      @if (exports.length === 0) {
        <div class="empty-state">
          <app-icon name="file" [size]="32" color="#9CA3AF"></app-icon>
          <p>No hay exportaciones</p>
        </div>
      } @else {
        <div class="exports-list">
          @for (file of exports; track file.id) {
            <div class="export-item" [class.processing]="file.status === ExportStatus.PROCESSING">
              <!-- Icono del archivo -->
              <div class="file-icon">
                <app-icon
                  name="file-text"
                  [size]="20"
                  color="#047857"></app-icon>
              </div>

              <!-- Información del archivo -->
              <div class="file-info">
                <div class="file-name">{{ file.fileName }}</div>
                <div class="file-meta">
                  <span>{{ file.createdAt | date:'dd/MM/yyyy, HH:mm' }}</span>
                  @if (file.fileSize) {
                    <span>•</span>
                    <span>{{ file.fileSize }}</span>
                  }
                </div>
                @if (file.status === ExportStatus.PROCESSING) {
                  <div class="processing-indicator">
                    <app-icon name="loader-circle" [size]="14" class="spinning"></app-icon>
                    <span>Procesando...</span>
                  </div>
                }
              </div>

              <!-- Estado y acciones -->
              <div class="export-actions">
                <!-- Badge de estado -->
                <div
                  class="status-badge"
                  [ngClass]="'status-' + file.status">
                  @if (file.status === ExportStatus.PROCESSING) {
                    <app-icon name="loader-circle" [size]="12" class="spinning"></app-icon>
                  }
                  @if (file.status === ExportStatus.PENDING) {
                    <span>Pendiente</span>
                  } @else if (file.status === ExportStatus.PROCESSING) {
                    <span>Procesando...</span>
                  } @else if (file.status === ExportStatus.COMPLETED) {
                    <span>Listo</span>
                  } @else if (file.status === ExportStatus.FAILED) {
                    <span>Falló</span>
                  } @else if (file.status === ExportStatus.CANCELLED) {
                    <span>Cancelado</span>
                  }
                </div>

                <!-- Botones de acción según estado -->
                <div class="action-buttons">
                  @if (file.status === ExportStatus.FAILED) {
                    <button
                      nz-button
                      nzType="text"
                      nzSize="small"
                      (click)="retryExport(file)"
                      class="action-btn retry-btn"
                      title="Reintentar">
                      <app-icon name="refresh-cw" [size]="14"></app-icon>
                    </button>
                  }
                  @if (file.status === ExportStatus.COMPLETED) {
                    <button
                      nz-button
                      nzType="text"
                      nzSize="small"
                      (click)="openExportLink(file)"
                      class="action-btn download-btn"
                      title="Abrir enlace">
                      <app-icon name="external-link" [size]="14"></app-icon>
                    </button>
                  }
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    (click)="removeExport(file)"
                    class="action-btn delete-btn"
                    title="Eliminar">
                      <app-icon name="trash-2" [size]="14"></app-icon>
                    </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </nz-card>
  </div>
}

